import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {delay, finalize, map} from 'rxjs/operators';

import {HISTORY_KEY_HISTORY_VIDEO, SearchParam} from '../../defines/client.const';
import {CONTENT_TYPE_JSON_UTF8, VIDEO_IN_API_URL} from '../../defines/protocol';
import {Video} from '../../models/video.model';
import {SearchHistory} from '../../models/history.model';
import {VideoLoader} from '../../interfaces/VideoLoader';
import {ApiService} from '../api/api.service';

@Injectable({
  providedIn: 'root',
})
export class VideoHistoryService implements VideoLoader {
  private history: SearchHistory = null;

  private load$: Observable<Array<Video>> = null;
  public IsLoading(): boolean {
    return this.load$ !== null;
  }

  constructor(
    private api: ApiService,
  ) {
    this.history = new SearchHistory({name: HISTORY_KEY_HISTORY_VIDEO});
  }

  public addHistory(no: number): void {
    this.history.addItem(String(no));
  }

  public GetList(param?: SearchParam): Observable<Array<Video>> {
    console.log('VideoHistoryService::GetList()', param);

    if (this.load$) {
      return this.load$;
    }

    if (this.history && this.history.empty()) {
      return new Observable<Array<Video>>(observer => {
        observer.next(null);
        observer.complete();
      }).pipe(delay(0));
    }

    const url = VIDEO_IN_API_URL;
    return this.load$ = this.api.Post(url, {list: this.history.list}, null, CONTENT_TYPE_JSON_UTF8).pipe(
      finalize(() => {
        this.load$ = null;
      }),
      map((data: []) => {
        console.log('VideoHistoryService::GetList()', data);
        const result = new Array<Video>();
        data.forEach(value => result.push(new Video(value)));
        return result;
      }),
      // catchError((err, caught: Observable<Array<Video>>) => {
      //   console.error('VideoHistoryService::GetList()', param, err);
      //   throwError(err);
      //   return caught;
      // })
    );
  }
}
